import React from "react";
import { X, Copy } from "lucide-react";
import { toast } from "sonner";

export default function ScanListView({ open, onClose, label, categories, text }) {
  if (!open) return null;
  const rows = categories.flatMap((c) => c.items.filter((i) => !i.checked));
  const copy = async () => {
    try { await navigator.clipboard.writeText(text); toast.success(`List copied — paste it into the ${label} app`); } catch { toast.error("Couldn't copy"); }
  };
  return (
    <div className="fixed inset-0 z-[60] bg-white overflow-y-auto" data-testid="scan-list-view">
      <div className="sticky top-0 bg-white/95 backdrop-blur px-5 py-3 flex items-center gap-2 border-b border-neutral-200">
        <div className="flex-1">
          <p className="font-heading font-bold text-lg text-black leading-tight">{label} list · {rows.length} items</p>
          <p className="text-xs text-neutral-600 font-semibold">Scan this screen with the {label} app, or copy and paste into your {label} list.</p>
        </div>
        <button onClick={copy} data-testid="scan-copy" aria-label="Copy list" className="w-10 h-10 rounded-full bg-black text-white flex items-center justify-center"><Copy size={16} strokeWidth={2.5} /></button>
        <button onClick={onClose} data-testid="scan-close" aria-label="Close" className="w-10 h-10 rounded-full bg-neutral-100 text-black flex items-center justify-center"><X size={18} strokeWidth={2.5} /></button>
      </div>
      <ol className="px-6 py-4 space-y-3">
        {rows.map((r) => (
          <li key={r.name} className="text-black text-xl font-semibold leading-snug" data-testid={`scan-row-${r.name}`}>
            {r.qty > 1 ? `${r.qty} x ` : ""}{r.product}
          </li>
        ))}
      </ol>
    </div>
  );
}
